import React, { useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NextArrow, PrevArrow } from "../wegats/arrows";
import { useSelector } from "react-redux";
import SectionLoader from "../sectionloader";
import LandingSection from "../landingsection";

function CenterMode() {
  const { topGames, loading } = useSelector((state) => state.interface);
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "10px",
    slidesToShow: 5,
    // speed: 1200,
    autoplay: false,
    pagination: true,
    // dots: true,
    // autoplaySpeed: 800,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 640,
        settings: {
          // slidesToShow: 1.68,
          slidesToShow: 1.008,
          centerPadding: "0px",
        },
      },
    ],
  };

  const images = useMemo(() => {
    return [...topGames].sort((a, b) => b.order - a.order);
  }, [topGames]);

  return (
    <>
      <LandingSection
        title="Top Awesome Games"
        description="Check out our library of the hotest games."
      >
        {loading ? (
          <SectionLoader height={400} />
        ) : (
          <div className="slider-container custom-slider-background relative">
            <Slider {...settings}>
              {images.map((image, index) => (
                <div key={index} className="slider-item px-3 md:px-4">
                  <img
                    src={image.url}
                    alt={`Slide ${index + 1}`}
                    className="slider-image w-full  h-auto rounded-lg shadow-md transition-transform duration-300 ease-in-out hover:scale-105"
                  />
                </div>
              ))}
            </Slider>
          </div>
        )}
      </LandingSection>
    </>
  );
}

export default CenterMode;
